// extracted by mini-css-extract-plugin
export default {"tableNumberBody":"style_tableNumberBody__Ufi60","tableNumber":"style_tableNumber__5a-c7","alarmIcon":"style_alarmIcon__TcmZl"};